import React from 'react'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'
import st from './Table.module.scss'

const THead = React.forwardRef(({ cols, mode = 'default' }, ref) => {
  const hasSub = () => cols.findIndex((x) => x.sub) !== -1
  const chekLink = (col) => {
    if (col.link) {
      return (
        <NavLink to={col.link} style={{ color: '#5f6368' }}>
          {col.name}
        </NavLink>
      )
    }
    return col.name
  }
  const renderTh = (col, idx) => {
    if (hasSub()) {
      if (col.sub) {
        return (
          <th key={idx} colSpan={col.sub.length}>
            {chekLink(col)}
          </th>
        )
      } else {
        return (
          <th key={idx} rowSpan={2}>
            {chekLink(col)}
          </th>
        )
      }
    } else {
      return <th key={idx}>{chekLink(col)}</th>
    }
  }

  return (
    <thead
      className={classNames({
        [st.thead]: mode === 'default',
        [st.theadNew]: mode === 'new',
      })}
      ref={ref}
    >
      <tr>{cols.map(renderTh)}</tr>

      {hasSub() && (
        <tr>
          {cols
            .filter((x) => x.sub)
            .map((col, idx) =>
              col.sub.map((sub, i) => (
                <th key={`${idx}-${i}`}>{chekLink(sub)}</th>
              )),
            )}
        </tr>
      )}
    </thead>
  )
})

export default THead
